<template>
  <v-container>
    <v-row>
      <v-col cols="4">
        <SelectField :name="label('year')" v-model="year" :items="years" @change="onChangeYear" :required="required"/>
      </v-col>
      <v-col cols="4">
        <SelectField :name="label('month')" v-model="month" :items="months" @change="onChangeMonth" :required="required"/>
      </v-col>
      <v-col cols="4">
        <SelectField :name="label('day')" v-model="day" :items="days" @change="onChangeDay" :required="required"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ComponentMixin from "@/components/ComponentMixin";
import moment from "moment";
import SelectField from "@/components/atoms/SelectField";

export default {
  components: {SelectField},
  mixins: [ComponentMixin],
  type: "molecule",
  name: "DateSelectField",
  props: {
    value: {
      type: String,
      required: false,
      default: null
    },
    name: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      year: null,
      month: null,
      day: null
    }
  },
  beforeMount() {
    if (this.value !== null) {
      if (this.value.length === 4) {
        const date = moment(this.value, "YYYY");
        this.year = date.year();
      } else {
        const date = moment(this.value, "YYYY-MM-DD");
        this.year = date.year();
        this.month = date.month() + 1;
        this.day = date.date();
      }
    }
  },
  computed: {
    years() {
      const years = [{label: '-', value: null}];
      const currentYear = moment().year();
      for (let year = currentYear; year >= 1900; year--) {
        years.push({label: year, value: year})
      }
      return years;
    },
    months() {
      const months = [{label: '-', value: null}];
      for (let month = 1; month <= 12; month++) {
        months.push({label: month, value: month})
      }
      return months;
    },
    days() {
      const days = [{label: '-', value: null}];
      const lastDay = this.daysInMonth(this.year, this.month);
      for (let day = 1; day <= lastDay; day++) {
        days.push({label: day, value: day})
      }
      return days;
    }
  },
  methods: {
    daysInMonth(year, month) {
      if (this.year !== null && this.month !== null) {
        return moment().year(year).month(month - 1).date(1).daysInMonth();
      } else {
        return 31;
      }
    },
    onChangeYear (value) {
      if (this.day !== null) {
        const lastDay = this.daysInMonth(value, this.month);
        if (lastDay < this.day) {
          this.day = lastDay;
        }
      }
      this.onChangeDate(value, this.month, this.day);
    },
    onChangeMonth (value) {
      if (this.day !== null) {
        const lastDay = this.daysInMonth(this.year, value);
        if (lastDay < this.day) {
          this.day = lastDay;
        }
      }
      this.onChangeDate(this.year, value, this.day);
    },
    onChangeDay (value) {
      this.onChangeDate(this.year, this.month, value);
    },
    onChangeDate (year, month, day) {
      if (year !== null && month !== null && day !== null) {
        const date = moment().year(year).month(month - 1).date(day).format("YYYY-MM-DD");
        this.$emit("input", date)
      }
    }
  }
}
</script>

<style scoped lang="sass">

</style>